// Reglas de créditos PUCV según "Créditos, Horas Proporción - Pregrado" (DDCYF, 2026-04-21).
// El crédito PUCV es el dato de entrada: de él salen los SCT y el máximo de horas del semestre.

// Cada crédito PUCV implica 4 horas pedagógicas PUCV semanales (lectivas + autónomas).
export const PUCV_WEEKLY_HOURS_PER_CREDIT = 4;
// Un semestre comprende 18 semanas corridas, incluidos los exámenes.
export const PUCV_SEMESTER_WEEKS = 18;
// La hora pedagógica PUCV corresponde a 35 minutos.
export const PUCV_PEDAGOGICAL_HOUR_MINUTES = 35;
// Cada crédito PUCV equivale a 1.5 créditos SCT Chile.
export const PUCV_SCT_PER_CREDIT = 1.5;

// Math.round redondea los .5 hacia arriba, igual que la tabla DDCYF (3 créditos → 5 SCT).
export function pucvSctCredits(pucv_credits) {
  const credits = parseFloat(pucv_credits);
  if (!credits || credits < 0) return 0;
  return Math.round(credits * PUCV_SCT_PER_CREDIT);
}

// Total de horas pedagógicas PUCV semanales: columna (A) de la tabla DDCYF.
export function pucvWeeklyHours(pucv_credits) {
  const credits = parseFloat(pucv_credits);
  if (!credits || credits < 0) return 0;
  return credits * PUCV_WEEKLY_HOURS_PER_CREDIT;
}

// Total de horas pedagógicas PUCV del semestre: columna (D) de la tabla DDCYF.
export function pucvMaxSemesterHours(pucv_credits) {
  return pucvWeeklyHours(pucv_credits) * PUCV_SEMESTER_WEEKS;
}

// Lleva las horas del formulario a horas pedagógicas PUCV (35 min), sin redondear.
// Las pedagógicas usan los minutos del módulo del tipo de perfil; las cronológicas, 60.
export function toPucvPedagogicalHours(
  pedagogical_hours,
  chronological_hours,
  module_minutes
) {
  const minutes =
    (parseFloat(pedagogical_hours) || 0) * (parseFloat(module_minutes) || 0) +
    (parseFloat(chronological_hours) || 0) * 60;
  return minutes / PUCV_PEDAGOGICAL_HOUR_MINUTES;
}
